import { render, staticRenderFns } from "./pos-table.vue?vue&type=template&id=529063b8&scoped=true&"
import script from "./pos-table.vue?vue&type=script&lang=js&"
export * from "./pos-table.vue?vue&type=script&lang=js&"
import style0 from "./pos-table.vue?vue&type=style&index=0&id=529063b8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529063b8",
  null
  
)

export default component.exports